import React from 'react';
import { objectToArray } from './objectHelpers';

const link = ['canonical'];
export const mapMetaData = (meta, title) => {
  const array = objectToArray(meta);

  return array.map((item, i) => {
    const { key, value } = item;
    if (key === 'title') return;

    if (link.includes(key)) {
      const linkAttributes = {
        rel: key,
        href: value,
      };
      return <link key={`SEO__${i}`} {...linkAttributes} data-react-helmet="true" />;
    }

    const attributes = {
      ...(key.includes('og:') ? { property: key } : { name: key }),
      ...(key.includes('og:title')
        ? { content: value !== '' ? value : meta.title || title }
        : { content: value }),
    };

    return <meta key={`SEO__${i}`} {...attributes} data-react-helmet="true" />;
  });
};
